import EngieWizard from '../modules/wizard.js';
import { debounce } from '../modules/functions.js';
import { toggleFields } from '../modules/form-helpers.js';
import { slideDown } from '../modules/animations.js';

window.dataLayer = window.dataLayer || [];

new toggleFields(document.querySelector('.entry-contractare'));

class EntryContractare {
	constructor(container) {
		if (!container) {
			throw new Error('container e null.');
		}

		this.wizard = new EngieWizard(container, {
			scrollOnStepChange: false,
			// devMode: true,
			// initialStep: 1,
		});

		this.container = container;

		this.form = container.querySelector('form');
		if (!(this.form && this.form instanceof HTMLFormElement)) {
			console.error(this.form);
			throw new Error('Nu exista <form> in container.');
		}

		this.flowId = this.form.dataset.flowId;
		if (!this.flowId) {
			console.error(this.form);
			throw new Error('Tagul <form> trebuie sa aiba atributul data-flow-id.');
		}

		this.fetchUrl = this.form.dataset.fetchUrl;
		if (!this.fetchUrl) {
			console.error(this.form);
			throw new Error('data-fetch-url e null.');
		}

		const divisionInput = container.querySelector('#division');
		this.division = divisionInput?.value;
		if (!this.division) {
			console.error(divisionInput);
			throw new Error('Nu am gasit divizia (division e null).');
		}

		// Descriptor contract dataLayer
		let service_name;

		switch (this.division) {
			case 'elec':
				service_name = 'Electricitate';
				break;
			case 'gaz':
				service_name = 'Gaze naturale';
				break;
			case 'gazelec':
				service_name = 'Electricitate și Gaze naturale';
				break;
			default:
				service_name = false;
		}

		if (service_name === false) {
			throw new Error('service_name poate fi doar "Electricitate", "Gaze naturale" sau "Electricitate și Gaze naturale".');
		}

		this.contractDescriptor = {
			service_type: 'Contract online - entry point',
			service_name,
		};

		const productInput = container.querySelector('#product');
		this.product = productInput?.value;
		if (!this.product) {
			console.error(productInput);
			throw new Error('Nu am gasit produsul (product e null).');
		}

		this.startFlowBtn = container.querySelector('#start-external-flow');
		if (!this.startFlowBtn) {
			console.error(this.startFlowBtn);
			throw new Error('Nu am gasit butonul de incepere contractare (#start-external-flow).');
		}

		/**
		 * Obiect localitate
		 * @type {Object}
		 * @property {HTMLInputElement} input Element input pentru localitate
		 * @property {HTMLElement} results Container rezultate
		 * @property {HTMLInputElement} inputValid Input hidden pentru extra validare pas
		 * @property {HTMLInputElement} city Input hidden oras
		 * @property {HTMLInputElement} countyCode Input hidden cod judet
		 * @property {HTMLElement} productUnavailableContainer Container mesaj indisponibilitate produs
		 * @property {HTMLElement} errorContainer Container mesaj eroare la fetch produs
		 * @property {string} initialMessage Mesaj initial afisat in lista de rezultate, daca sunt mai putin de 3 caractere in `input`
		 * @property {string} disabledClasses Clase CSS elemente dezactivate in lista de rezultate
		 * @property {string} noResultsMsg Mesajul care se afiseaza cand nu s-a gasit nicio localitate
		 */
		this.location = {
			input: container.querySelector('#location'),
			results: container.querySelector('#location-results'),
			inputValid: container.querySelector('#location-valid'),
			city: container.querySelector('#city'),
			countyCode: container.querySelector('#county-code'),
			productUnavailableContainer: container.querySelector(`#${this.flowId}-product-unavailable`),
			errorContainer: container.querySelector(`#${this.flowId}-product-error`),
			initialMessage: container.querySelector('#location-results')?.querySelector('li')?.textContent?.trim() || 'Scrie cel puțin 3 caractere.',
			disabledClasses: container.querySelector('#location-results')?.querySelector('li')?.getAttribute('class') || 'disabled text-gray-600',
			noResultsMsg: container.querySelector('#location-results')?.dataset.noResults || 'Nu am găsit nicio localitate.',
		};

		// Validare obiect localitate
		const locationValid = Object.values(this.location).every((v) => v != null);
		if (!locationValid) {
			const ids = ['#location', '#location-results', '#location-valid', '#city', '#county-code', `#${this.flowId}-product-unavailable`, `#${this.flowId}-product-error`];
			console.error(this.location);
			throw new Error(`Obiectul nu trebuie sa contina nicio valoare null sau undefined. Verifica inputurile ${ids.join(', ')}.`);
		}

		/**
		 * Obiect nonces
		 * @property {string} location Nonce localitate - se verifica la fetch localitati
		 * @property {string} product Nonce produs - se verifica la fetch produs
		 * @property {string} house Nonce produs - se verifica la fetch lista de tipuri de locuinte
		 * @property {string} main Nonce principal - se verifica inainte de a scrie obiectul localStorage
		 */
		this.nonces = {
			location: container.querySelector('#location-nonce')?.value,
			product: container.querySelector('#product-nonce')?.value,
			house: container.querySelector('#housing-nonce')?.value,
			prognosis: container.querySelector('#prognosis-nonce')?.value,
			main: container.querySelector('#_wpnonce')?.value,
		};

		// Validare nonces
		const noncesValid = Object.values(this.nonces).every((v) => v != null);
		if (!noncesValid) {
			const ids = ['#location-nonce', '#product-nonce', '#housing-nonce', '#prognosis-nonce', '#_wpnonce'];
			console.error(this.nonces);
			throw new Error(`Obiectul nu trebuie sa contina nicio valoare null sau undefined. Verifica inputurile ${ids.join(', ')}.`);
		}

		/**
		 * Obiect pret - pasul 1
		 * @property {HTMLElement} placeholder Se afiseaza cand facem fetch
		 * @property {HTMLElement} span Span de populat cu valoarea care vine din request
		 * @property {HTMLElement} input Input hidden validare pas
		 */
		this.price = {
			container: container.querySelector('#price-container'),
			placeholder: container.querySelector('#price-placeholder'),
			span: container.querySelector('#price-container .price'),
			input: container.querySelector('#price'),
		};

		// Validare obiect pret
		const priceValid = Object.values(this.price).every((v) => v != null);
		if (!priceValid) {
			console.error(this.price);
			throw new Error('Obiectul nu trebuie sa contina nicio valoare null sau undefined. Verifica #price-container, #price-placeholder, #price-container .price si inputul #price.');
		}

		// Tipuri de locuinte
		this.houseTypes = null;
		this.houseTypeSelect = container.querySelector('#house-type');
		if (!this.houseTypeSelect) {
			console.error(this.houseTypeSelect);
			throw new Error('Nu am gasit selectul de tipuri de locuinta (#house-type).');
		}

		// Prognoza consum
		this.prognosisInput = container.querySelector('#est-consumption');
		if (!this.prognosisInput) {
			console.error(this.prognosisInput);
			throw new Error('Nu am gasit inputul pentru prognoza de consum (#est-consumption).');
		}

		// Mesaj eroare comun tipuri de locuinte + prognoza
		this.housePrognosisErrorContainer = container.querySelector(`#${this.flowId}-house-prognosis-error`);
		if (!this.housePrognosisErrorContainer) {
			console.error(this.housePrognosisErrorContainer);
			throw new Error(`Nu am gasit containerul de eroare pentru tipul de locuinta si prognoza de consum (#${this.flowId}-house-prognosis-error)`);
		}

		this.addListeners();
		this.getLocations();
		this.handleLocationsNav();
		this.getProduct();
		this.getHouseTypes();
		this.getPrognosis();
		this.startFlow();
	}

	addListeners() {
		// Prevent form submit
		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
		});

		// Toggle rezultate localitati
		this.location.input.addEventListener('focus', (e) => {
			e.preventDefault();
			this.location.results.classList.add('is-visible');
		});
		this.location.input.addEventListener('blur', (e) => {
			e.preventDefault();
			this.location.results.classList.remove('is-visible');
		});

		this.container.addEventListener('engieWizard:updateStep', (e) => {
			const { currentStep, totalSteps, direction } = e.detail;

			// Afisare buton incepere flow extern in ultimul pas
			this.startFlowBtn.hidden = !(currentStep === totalSteps);

			// dataLayer:flow_step_completed - final pasul 1
			if (currentStep === 2 && direction === 'next') {
				const city = this.form.querySelector('#city').value;

				window.dataLayer.push({
					event: 'flow_step_completed',
					step_number: '1.2',
					step_label: 'Localitate',
					step_selected_option: city,
					contract: {
						...this.contractDescriptor,
						city,
					},
				});
			}

			// dataLayer:flow_step_completed - final pasul 2
			if (currentStep === 3 && direction === 'next') {
				const city = this.form.querySelector('#city').value;
				const selectedOption = this.form.querySelector('[name="contract_status"]:checked')?.value;
				const contractStatus = selectedOption === 'has_contract' ? 'Am contract cu alt furnizor' : 'Locuința nu este încă racordată la utilități';

				window.dataLayer.push({
					event: 'flow_step_completed',
					step_number: '-',
					step_label: 'Tip serviciu - entry point',
					step_selected_option: contractStatus,
					contract: {
						...this.contractDescriptor,
						service_category: contractStatus,
						city,
					},
				});
			}
		});

		// Activare buton incepere flow extern daca ultimul pas e valid
		this.container.addEventListener('engieWizard:validateStep', (e) => {
			const { currentStep, totalSteps, isValid } = e.detail;
			if (currentStep !== totalSteps) {
				return;
			}
			this.startFlowBtn.disabled = !isValid;
		});

		// dataLayer:flow_stop - prosumator
		this.form.querySelector('#yes-prosumer')?.addEventListener('click', () => {
			window.dataLayer.push({
				event: 'flow_stop',
				flow_stop_reason: 'Serviciu indisponibil pentru prosumatori',
				contract: {
					...this.contractDescriptor,
					city: this.form.querySelector('#city')?.value,
				},
			});
		});
	}

	/**
	 * Interogare API localitati cu delay in functie de viteza de tastare
	 */
	getLocations() {
		// Debounce delay adaptiv
		let lastKeyTime = 0;
		let avgInterval = 250;
		let delay = 200;
		this.location.input.addEventListener('input', (e) => {
			const now = Date.now();

			if (lastKeyTime) {
				const interval = now - lastKeyTime;
				avgInterval = avgInterval * 0.7 + interval * 0.3;
			}
			lastKeyTime = now;

			delay = Math.max(200, Math.min(avgInterval * 1.5, 350));
		});

		// Interogare localitati
		this.location.input.addEventListener(
			'input',
			debounce(
				async (e) => {
					e.preventDefault();

					if (this.location.input.value.length < 3) {
						this.location.results.innerHTML = `<li class="${this.location.disabledClasses}">${this.location.initialMessage}</li>`;
						return;
					}

					const formData = new FormData();
					formData.append('search', this.location.input.value);
					formData.append('_wpnonce', this.nonces.location);
					formData.append('action', 'get_location');

					// Afisare spinner
					this.container.querySelector('#location-spinner')?.removeAttribute('hidden');

					const url = new URL(this.fetchUrl);
					url.searchParams.set('action', 'get_location');

					// Ajax call pentru interogare endpoint localitati
					const res = await fetch(url, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(Object.fromEntries(formData)),
					});

					const { success, data: locations } = await res.json();

					// Ascundere spinner
					this.container.querySelector('#location-spinner')?.setAttribute('hidden', 'hidden');

					if (success) {
						let innerList = [];
						locations.forEach((location) => {
							const { city, county, countyCode } = location;
							innerList.push(`<li><button type="button" data-city="${city}" data-county="${county}" data-county-code="${countyCode}">${city}, ${county}</button></li>`);
						});

						this.location.results.innerHTML = innerList.join('');

						// Adauga eventuri pe butoane
						const buttons = [...this.location.results.querySelectorAll('button')];
						buttons.forEach((btn) => {
							// Aplicam clasa hover la mousemove. Necesar pentru navigare din sageti
							btn.addEventListener('mousemove', (e) => {
								e.preventDefault();
								btn.classList.add('hover');
								buttons.filter((b) => b !== btn).forEach((b) => b.classList.remove('hover'));
							});
							// Populare inputuri la click pe buton
							btn.addEventListener('click', (e) => {
								e.preventDefault();
								const city = btn.dataset.city;
								const county = btn.dataset.county;
								const countyCode = btn.dataset.countyCode;

								// Daca avem deja valorile in inputurile hidden, nu mai populam -> nu se mai face getProduct()
								if (this.location.city.value === city && this.location.countyCode.value === countyCode) {
									this.location.input.blur();
									return;
								}

								if (city && county && countyCode) {
									this.location.input.value = `${city}, ${county}`;
									this.location.input.blur();
									this.location.inputValid.value = 'valid';
									this.location.inputValid.dispatchEvent(new Event('change', { bubbles: true }));

									// Populare inputuri hidden
									this.location.city.value = city;
									this.location.countyCode.value = countyCode;
								}
							});
						});
					} else {
						this.location.results.innerHTML = `<li class="${this.location.disabledClasses}">${this.location.noResultsMsg}</li>`;

						const { reason } = locations;
						const { error_message, api_error } = this.errorData(reason);

						// dataLayer:flow_error
						window.dataLayer.push({
							event: 'flow_error',
							step_label: 'entrypoint 1',
							error_message,
							api_error,
						});
					}
				},
				() => delay,
			),
		);
	}

	/**
	 * Interogare endpoint produse
	 * @param {string} quantity Cantitate estimata. Default ''
	 */
	getProduct(quantity = '') {
		const handleLocationChange = async () => {
			const selectedCity = this.location.city.value;
			const selectedCounty = this.location.countyCode.value;

			if (!(selectedCity && selectedCounty)) {
				return;
			}

			const formData = new FormData();
			formData.append('division', this.division);
			formData.append('product', this.product);
			formData.append('city', selectedCity);
			formData.append('county', selectedCounty);

			// Cantitate - daca s-a specificat
			if (quantity) {
				formData.append('quantity', quantity);
			}

			formData.append('action', 'get_product');
			formData.append('_wpnonce', this.nonces.product);

			// Ascundere mesaje
			this.location.productUnavailableContainer.hidden = true;
			this.location.errorContainer.hidden = true;

			try {
				this.price.container.hidden = true;
				this.price.placeholder.hidden = false;
				this.price.input.value = '';
				this.price.input.dispatchEvent(new Event('change', { bubbles: true }));

				const url = new URL(this.fetchUrl);
				url.searchParams.set('action', 'get_product');

				// Ajax call pentru interogare endpoint localitati
				const res = await fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(Object.fromEntries(formData)),
				});

				const { success, data } = await res.json();

				if (success) {
					const { price } = data;

					this.price.span.textContent = price;
					this.price.container.hidden = false;
					this.price.input.value = price;
					this.price.input.dispatchEvent(new Event('change', { bubbles: true }));
				} else {
					// Afisare mesaj indisponibilitate
					this.location.productUnavailableContainer.hidden = false;

					const { reason } = data;
					const { error_message, api_error, flow_stop, flow_error } = this.errorData(reason);

					// dataLayer:flow_error
					if (flow_error === true) {
						window.dataLayer.push({
							event: 'flow_error',
							step_label: 'entrypoint 1',
							error_message,
							api_error,
						});
					}

					// dataLayer:flow_stop - produs indisponibil
					else if (flow_stop === true) {
						window.dataLayer.push({
							event: 'flow_stop',
							flow_stop_reason: error_message,
							contract: {
								...this.contractDescriptor,
								city: formData.get('city'),
							},
						});
					}
				}
			} catch (err) {
				console.error(err.message);
				this.location.errorContainer.hidden = false;

				// dataLayer:flow_error
				window.dataLayer.push({
					event: 'flow_error',
					step_label: 'entrypoint 1',
					error_message: err.message,
					api_error: 'no',
				});
			} finally {
				this.price.placeholder.hidden = true;
			}
		};

		// Folosim MutationObserver pentru ca eventul change pe inputuri hidden nu e consistent in browsere
		const observer = new MutationObserver(handleLocationChange);
		[this.location.city, this.location.countyCode].forEach((input) => {
			observer.observe(input, {
				attributes: true,
				attributeFilter: ['value'],
			});
		});
	}

	getHouseTypes() {
		this.container.addEventListener('engieWizard:updateStep', async (e) => {
			const { currentStep, totalSteps } = e.detail;

			// Aducem tipurile de locuinte in ultimul pas
			if (currentStep !== totalSteps) {
				return;
			}

			// Daca tipurile de locuinta sunt salvate, nu mai facem nimic
			if (this.houseTypes !== null) {
				return;
			}

			const formData = new FormData();
			formData.append('_wpnonce', this.nonces.house);
			formData.append('action', 'get_house_types');

			// Ascundere eroare
			this.housePrognosisErrorContainer.hidden = true;

			try {
				const url = new URL(this.fetchUrl);
				url.searchParams.set('action', 'get_house_types');

				const res = await fetch(url, {
					method: 'post',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(Object.fromEntries(formData)),
				});

				const { success, data: houseTypes } = await res.json();

				if (success) {
					this.houseTypes = houseTypes;
					this.populateHouseTypes();
				} else {
					this.housePrognosisErrorContainer.hidden = false;

					const { reason } = houseTypes;
					const { error_message, api_error, flow_stop, flow_error } = this.errorData(reason);

					// dataLayer:flow_error
					if (flow_error === true) {
						window.dataLayer.push({
							event: 'flow_error',
							step_label: 'entrypoint 3',
							error_message,
							api_error,
						});
					}
				}
			} catch (err) {
				this.housePrognosisErrorContainer.hidden = false;

				// dataLayer:flow_error
				window.dataLayer.push({
					event: 'flow_error',
					step_label: 'entrypoint 3',
					error_message: err.message,
					api_error: 'no',
				});
			}
		});
	}

	populateHouseTypes() {
		if (!Array.isArray(this.houseTypes)) {
			return;
		}

		let list = '';

		this.houseTypes.forEach((type) => {
			const { code, description } = type;
			list += `<option value="${code}">${description}</option>`;
		});

		this.houseTypeSelect.innerHTML += list;
	}

	/**
	 * Metoda consolidata pentru:
	 * - navigare cu tastatura in lista de rezultate
	 * - populare input localitate si inputuri hidden necesare la Enter
	 * - resetare inputuri -> invalidare pas daca se schimba ceva in location.input
	 */
	handleLocationsNav() {
		this.location.input.addEventListener('keydown', (e) => {
			const isArrow = e.key === 'ArrowDown' || e.key === 'ArrowUp';
			const isEnter = e.key === 'Enter';

			if (isArrow) {
				// Toate butoanele
				const resultBtns = this.location.results.querySelectorAll('button');

				// Luam primul buton cu clasa .hover; daca nu exista, fallback la primul buton
				const btn = this.location.results.querySelector('button.hover') || this.location.results.querySelector('button');

				if (btn) {
					if (btn.classList.contains('hover')) {
						// Ne raportam la butonul cu .hover
						const index = [...resultBtns].indexOf(btn);
						let nextBtn;
						if (e.key === 'ArrowDown') {
							nextBtn = resultBtns[index + 1];
						} else {
							nextBtn = resultBtns[index - 1];
						}
						if (nextBtn) {
							nextBtn.classList.add('hover');
							[...resultBtns].filter((b) => b !== nextBtn).forEach((b) => b.classList.remove('hover'));
							// Scroll into view, e posibil ca butonul sa nu fie vizibil - simulare scroll pe container
							nextBtn.scrollIntoView({
								behavior: 'smooth',
								block: 'nearest',
							});
						}
					} else {
						resultBtns[0].classList.add('hover');
						// Nu mai e necesar scroll into view, e primul buton si e vizibil
					}
				}
			}

			// Event click pt populare inputuri
			if (isEnter) {
				e.preventDefault();
				this.location.results.querySelector('button.hover')?.click();
			}

			// Reset validare pas daca se schimba ceva in input
			const excludedKeys = ['ArrowDown', 'ArrowUp', 'Enter', 'ArrowLeft', 'ArrowRight', 'Control', 'Alt', 'Shift', 'Meta', 'Tab', 'CapsLock', 'Home', 'End'];
			if (!excludedKeys.includes(e.key)) {
				this.resetLocationInputs();
				this.resetPriceInput();
				this.location.productUnavailableContainer.hidden = true;
				this.location.errorContainer.hidden = true;
				// this.location.msgContainer.hidden = true;
			}
		});
	}

	getPrognosis() {
		this.houseTypeSelect.addEventListener('change', async () => {
			const formData = new FormData();

			formData.append('housing_type', this.houseTypeSelect.value);
			formData.append('division', this.division);
			formData.append('action', 'get_prognosis');
			formData.append('_wpnonce', this.nonces.prognosis);

			// Ascundere eroare
			this.housePrognosisErrorContainer.hidden = true;

			try {
				// Afisare spinner
				this.container.querySelector('#consumption-spinner')?.removeAttribute('hidden');

				const url = new URL(this.fetchUrl);
				url.searchParams.set('action', 'get_prognosis');

				const res = await fetch(url, {
					method: 'post',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(Object.fromEntries(formData)),
				});

				const { success, data: avgMonthlyConsumption } = await res.json();

				if (success) {
					this.prognosisInput.value = avgMonthlyConsumption;
					this.prognosisInput.dispatchEvent(new Event('change', { bubbles: true }));
				} else {
					this.housePrognosisErrorContainer.hidden = false;

					const { reason } = avgMonthlyConsumption;
					const { error_message, api_error, flow_stop, flow_error } = this.errorData(reason);

					// dataLayer:flow_error
					if (flow_error === true) {
						window.dataLayer.push({
							event: 'flow_error',
							step_label: 'entrypoint 3',
							error_message,
							api_error,
						});
					}
				}
			} catch (err) {
				console.error(err.message);
				this.housePrognosisErrorContainer.hidden = false;

				// dataLayer:flow_error
				window.dataLayer.push({
					event: 'flow_error',
					step_label: 'entrypoint 3',
					error_message: err.message,
					api_error: 'no',
				});
			} finally {
				// Ascundere spinner
				this.container.querySelector('#consumption-spinner')?.setAttribute('hidden', 'hidden');
			}
		});
	}

	startFlow() {
		this.startFlowBtn.addEventListener('click', (e) => {
			e.preventDefault();

			const formData = new FormData(this.form);

			let flowType = false;

			switch (formData.get('contract_status')) {
				case 'has_contract':
					flowType = 'newProvider';
					break;
				case 'no_contract':
					flowType = 'noUtilities';
					break;
			}

			if (flowType === false) {
				console.error(formData);
				throw new Error('flowType e false.');
			}

			const payload = {
				date: new Date().toISOString(),
				channel: 'site',
				division: formData.get('division'),
				product: {
					code: formData.get('product'),
					centralHeatingPackage: null,
					isRetention: false,
				},
				flowType,
				clientTypeCode: 'CS',
				address: {
					county: formData.get('county_code'),
					city: formData.get('city'),
					houseType: formData.get('house_type'),
				},
				averageMonthlyConsumption: formData.get('estimate_consumption'),
			};

			localStorage.setItem('contractare_entrypoint', JSON.stringify(payload));

			// dataLayer:flow_start
			window.dataLayer.push({
				event: 'flow_start',
				step_number: '-',
				step_label: 'Start flux - entry point',
				step_selected_option: formData.get('prosumer_status') === 'no_prosumer' ? 'Nu' : 'Da',
				contract: {
					...this.contractDescriptor,
					service_category: formData.get('contract_status') === 'no_contract' ? 'Locuința nu este încă racordată la utilități' : 'Am contract cu alt furnizor',
					city: formData.get('city'),
				},
			});

			window.location.href = '/contract-online?wizard=true';
		});
	}

	errorData(reason) {
		let error_message, api_error, flow_stop, flow_error;

		switch (reason) {
			case 'wp_error':
				error_message = 'Eroare WordPress';
				api_error = 'no';
				flow_stop = false;
				flow_error = true;
				break;
			case 'response_body_empty':
				error_message = 'Interogarea a returnat un raspuns gol';
				api_error = 'no';
				flow_stop = false;
				flow_error = true;
				break;
			case 'json_error':
				error_message = 'Eroare decodificare json';
				api_error = 'no';
				flow_stop = false;
				flow_error = true;
				break;
			case 'not_found':
				error_message = 'Niciun rezultat gasit';
				api_error = 'no';
				flow_stop = false;
				flow_error = true;
				break;
			case 'api_error':
				error_message = 'Eroare interogare API';
				api_error = 'yes';
				flow_stop = false;
				flow_error = true;
				break;
			case 'product_unavailable':
				error_message = 'Serviciu indisponibil in localitatea selectata';
				api_error = 'no';
				flow_stop = true;
				flow_error = false;
				break;
			default:
				error_message = 'Eroare neasteptata';
				api_error = 'no';
				flow_stop = false;
				flow_error = true;
		}

		return { error_message, api_error, flow_stop, flow_error };
	}

	resetLocationInputs() {
		this.location.inputValid.value = '';
		this.location.city.value = '';
		this.location.countyCode.value = '';
		this.location.inputValid.dispatchEvent(new Event('change', { bubbles: true }));
		this.location.city.dispatchEvent(new Event('change', { bubbles: true }));
		this.location.countyCode.dispatchEvent(new Event('change', { bubbles: true }));
	}

	resetPriceInput() {
		this.price.container.hidden = true;
		this.price.input.value = '';
		this.price.input.dispatchEvent(new Event('change', { bubbles: true }));
	}
}

function initContractare() {
	new EntryContractare(document.querySelector('.entry-contractare'));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initContractare);
} else {
	initContractare();
}
